import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import { Button, Field, inputClass, cx } from '../components/ui';

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect nếu đã đăng nhập
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await login(email, password);

      if (result.success) {
        toast.success('Đăng nhập thành công!');
        navigate('/dashboard');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Có lỗi xảy ra khi đăng nhập');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="hidden w-[42%] max-w-xl flex-col justify-between bg-gray-900 p-10 text-white lg:flex">
        <div className="flex items-center gap-2.5">
          <img src="/logo-icon.png" alt="" className="h-9 w-9" />
          <span className="text-lg font-semibold">CaskBack</span>
        </div>
        <div>
          <p className="text-3xl font-semibold leading-snug tracking-tight">
            Đối soát đơn, duyệt rút tiền và theo dõi tăng trưởng ở cùng một nơi.
          </p>
          <div className="mt-5 h-1 w-14 rounded-full bg-gold-400" />
        </div>
        <p className="text-sm text-gray-400">Trang nội bộ dành cho quản trị viên.</p>
      </aside>

      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <img src="/logo-icon.png" alt="CaskBack" className="mb-6 h-12 w-12 lg:hidden" />
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Đăng nhập quản trị</h1>
          <p className="mt-1 text-sm text-gray-500">Dùng tài khoản admin CaskBack của bạn.</p>

          <form className="mt-7 space-y-4" onSubmit={handleSubmit}>
            <Field label="Email">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputClass}
                placeholder="ten@caskback.vn"
                autoComplete="off"
                required
              />
            </Field>

            <Field label="Mật khẩu">
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={cx(inputClass, 'pr-10')}
                  placeholder="Nhập mật khẩu"
                  autoComplete="off"
                  required
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-700"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
                >
                  {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            </Field>

            <Button type="submit" loading={isLoading} className="w-full">
              {isLoading ? 'Đang đăng nhập...' : 'Đăng nhập'}
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
